import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { FiClock, FiUsers } from 'react-icons/fi';
import { PlayfulCard, PlayfulCardButton } from '@/components/custom/playful-card';
import monitoriaIcon from '@/assets/images/icons/monitoria.png';

export function AuditoriumPlayfulCard({ auditorium, setActiveAuditorium }) {
  const navigate = useNavigate();
  const isOnline = auditorium.status === 'Online';
  const lastUpdate = auditorium?.['auditorium-lesson'] ? auditorium?.['auditorium-lesson']?.['updated-at'] : auditorium['updated-at'];

  return (
    <PlayfulCard
      className="p-6"
      badge={{ text: auditorium.status, variant: isOnline ? 'success-soft' : 'muted' }}
    >
      <img
        src={monitoriaIcon}
        alt=""
        aria-hidden="true"
        className="h-20 w-20 object-contain"
      />

      <h3
        className="mb-0 mt-3 line-clamp-2 text-base font-extrabold text-neutral-900"
        title={auditorium.name}
      >
        {auditorium.name}
      </h3>

      {auditorium?.['auditorium-lesson']?.name && (
        <p
          className="mb-0 mt-0.5 truncate text-sm text-neutral-dark"
          title={auditorium['auditorium-lesson'].name}
        >
          {auditorium['auditorium-lesson'].name}
        </p>
      )}

      <div className="mb-6 mt-4 flex flex-1 items-center gap-4 text-sm text-neutral-500">
        <button
          type="button"
          onClick={() => setActiveAuditorium(auditorium)}
          className="flex items-center gap-1.5 font-semibold transition-opacity hover:opacity-70"
        >
          <FiUsers className="h-4 w-4 text-[var(--color-mission-medium)]" />
          {auditorium?.['student-count'] ?? 0} participantes
        </button>
      </div>

      <PlayfulCardButton onClick={() => navigate(`/auditorio/${auditorium.id}`)}>Acessar</PlayfulCardButton>
    </PlayfulCard>
  );
}
